
<div :class="jel_getClassObject(content)">
  <MediaImageFocalPoint
    :content="{
      formatRatio: '1x1',
      image: content.image,
      isBackground: true,
      altImage: content.altImage,
    }"
    class="overflow-hidden image-fond"
  >
  </MediaImageFocalPoint>
  <div class="images-supplementaires position-absolute d-flex align-items-center">
    <!-- bloc pour le logo -->
    <MediaImageFocalPoint
      v-if="content.image2"
      :content="{
        isLogo: true,
        formatRatio: '16x9',
        image: content.image2,
      }"
      class="overflow-hidden position-absolute image-logo image-centrale h-100 w-100"
    />
    <!-- bloc pour l'image de personnage -->
    <MediaImageFocalPoint
      v-else-if="content.image3"
      :content="{
        formatRatio: '1x1',
        image: content.image3,
      }"
      class="overflow-hidden position-absolute image-personnage h-100"
    />
  </div>
</div>
